import api from "@/config/http-client-gateway";
import { showErrorToast, showInfoToast, showWarningToast } from '@/kernel/alerts';

export const getUsersService = async (params) => {
    try {
        const { data } = await api.doGet('/users-frontera', params);
        return data;
    } catch (error) {
        console.log("Error ", error);
        showErrorToast("Error al obtener los usuarios");
        return error;
    }
}

export const registerUserService = async (formData) => {
    try {
        const { data } = await api.doPost('/register-user-cobre-frontera', formData);
        return data;
    } catch (error) {
        showErrorToast("Error al registrar el usuario");
        if (error.response.status === 400) {
            if (error.response.data?.message === "User already exists") {
                showWarningToast("El usuario ya existe");           
            }
            if (error.response.data?.message === "Password is not accepted") {
                showInfoToast("La contraseña debe tener al menos 6 caracteres e incluir al menos un dígito. Solo se permiten letras, dígitos, Ññ, @, _ y -.");
            }

            if (error.response.data?.message=== "Email is not accepted") {
                showInfoToast("El correo electrónico no es válido");
            }
        }
        return error;
    }
}

export const updateUserService = async (formData) => {
    try {
        const { data } = await api.doPut('/update-user-frontera', formData);
        return data;
    } catch (error) {
        console.log("Error ", error.response.data?.message);
        showErrorToast("Error al actualizar el usuario");
        if (error.response.data?.message === "User already exists") {
            showWarningToast("El usuario ya existe");
        }
        if (error.response.data?.message === "Invalid password format") {
            showInfoToast("La contraseña debe tener al menos 6 caracteres e incluir al menos un dígito. Solo se permiten letras, dígitos, Ññ, @, _ y -.");
        }
        if (error.response.data?.message === "Invalid email format") {
            showInfoToast("El correo electrónico no es válido");
        }
        return error;
    }
}

export const deleteUserService = async (formData) => {
    try {
        const { data } = await api.doDelete('/delete-user-frontera', formData);
        return data;
    } catch (error) {
        console.log("Error ", error);
        showErrorToast("Error al eliminar el usuario");
        return error;
    }
}